import { useEffect, useState } from "react";

type NavigationDataKey = '/lesson-recording/start-in-person-lesson';

class NavigationData {
  private static instance: NavigationData;
  private data: Record<string, any> = {};

  private constructor() {
    this.data = {};
  }

  public static getInstance(): NavigationData {
    if (!NavigationData.instance) {
      NavigationData.instance = new NavigationData();
    }
    return NavigationData.instance;
  }

  public setData(key: string, value: any) {
    this.data[key] = value;
  }

  public getData(key: string) {
    return this.data[key];
  }
}

export const setNavigationData = (key: NavigationDataKey, value: any) => {
  NavigationData.getInstance().setData(key, value);
};

const getNavigationData = (key: NavigationDataKey) => {
  return NavigationData.getInstance().getData(key);
};

function useNavigationData<T>(key: NavigationDataKey) {
  const [data, setData] = useState<T>(getNavigationData(key));

  useEffect(() => {
    setData(getNavigationData(key));
  }, [key]);

  return data;
}

export default useNavigationData;
